<template>
    <div id="mr-hide" v-if="showPopup" class="popup-overlay">
     
      <div v-for="topoffer in topoffers" :key="topoffer.id" class="container popup">
       <div class="modal-main d-flex">
        <div class="col-sm-12 com-md-12 col-lg-6">
            <img  :src="this.adminurl + 'fontend/offer/'+ topoffer.image" alt="">
        </div>
        <div class="col-sm-12 col-md-12 col-lg-6">
            <div class="closeicon">
            <i @click="closePopup" class="fa fa-times top-icon"></i>
            <h1 class="headtitles">I’m available to support you.</h1>
            <p class="py-3 text-center">35+ specialized doctors from 19+ departments</p>
            <div class="text-center">
              <router-link to="/appointment" class=" fs-2 mt-3 btn btn-bg cs-slider-btn">Book Appiontment</router-link>
            </div>
          
        </div>
        </div>
       
       </div>
      </div>
    </div>


    <div id="whymobileShow" v-if="showPopup" class="popup-overlay pt70 pb70">
     <div v-for="topoffer in topoffers" :key="topoffer.id" class="container-fluid left-right">
      <div class="modal-main bg-white">
        <i @click="closePopup" class="fa fa-times top-icon py-5"></i>
       <div class="col-sm-12 com-md-12 col-lg-6">
           <img  :src="this.adminurl + 'fontend/offer/'+ topoffer.image" alt="">
       </div>
       <div class="col-sm-12 col-md-12 col-lg-6">
           <div class="closeicon">
           <h1 class="headtitles fs-54">I’m available to support you.</h1>
           <p class=" fs-40 py-3 text-center">35+ specialized doctors from 19+ departments</p>
           <div class="text-center py-5">
             <router-link to="/appointment" class="fs-54 my-3 btn btn-bg cs-slider-btn">Book Appiontment</router-link>
           </div>
         
       </div>
       </div>
      
      </div>
     </div>
   </div>
  </template>
  
  <script>
import axios from 'axios';
  export default {
    computed: {
    adminurl() {
      return this.$store.state.adminurl;

    },
    url() {
      return this.$store.state.url;
    }
  },
    data() {
      return {
        showPopup: false,
        topoffers:[],
      };
    },
    methods: {
      closePopup() {
        this.showPopup = false;
      },


      fetchoffer() {
      axios.get(this.adminurl + 'api/offer')
        .then(response => {
          this.topoffers = response.data.offers;
        })
        .catch(error => {
          console.error('There was an error fetching the notice data:', error);
        });
    },
    },
    mounted() {
        this.showPopup = true;
        this.fetchoffer();
    }
  };
  </script>
  
  <style scoped>
  .headtitles {
    text-align: center;
    margin-top: 50px;
    font-weight: 200;
    text-transform: uppercase;
    letter-spacing: 0.1px;
    word-spacing: 3px;
    -webkit-text-stroke-width: 1px;
    stroke-width: 1px;
    -webkit-text-stroke-color: #000;
    stroke: #000;
    color: #18397a;
}
.top-icon {
    text-align: right;
    color: black;
    font-size: 29px;
    color: white;
    margin-left: 539px;
    color: black;
    cursor: pointer;
}
 .modal-main {
    width: 100%;
 }
.popup-overlay {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.8);
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 1000;
}
  
  .popup {
    background: white;
    padding: 20px;
    border-radius: 5px;
    box-shadow: 0 0 20px rgba(0, 0, 0, 0.7);
}
  .btn-bg {
    background-color: #163778;
    color: #fff;
    padding: 10px 35px;
  }

  </style>